import { Injectable, TemplateRef } from '@angular/core';

export class BaseOptions {
  visible?: boolean = false;
  focus?: boolean = true;
  closable?: boolean = false;
  maskClosable?: boolean = true;
  onClose?: any;
  transparent?: boolean = false;
  popup?: boolean = false;
  animationType?: string;
  title?: string | TemplateRef<any>;
  footer?: Array<any>;
  platform?: string;
  className?: string;
  wrapClassName?: string;
  message?: string | TemplateRef<any>;
  actions?: Array<any>;
  callbackOrActions?: Array<any>;
  type?: string;
  defaultValue?: string;
  placeholders?: Array<any>;
  operation?: boolean;
  transitionName?: string = 'am-zoom';
  maskTransitionName?: string = 'am-fade';
  close: () => void;
}

@Injectable()
export class ModalOptions extends BaseOptions {}

@Injectable()
export class AlertOptions extends BaseOptions {
  /**
   * 	æç¤ºä¿¡æ¯
   */
  message?: string | TemplateRef<any>;

  /**
   * æé®ç», [{text, onPress, style}]
   */
  actions?: Array<any>;
}

@Injectable()
export class PromptOptions extends BaseOptions {
  /**
   * 	æç¤ºä¿¡æ¯
   */
  message?: string | TemplateRef<any>;

  /**
   * æé®ç» [{text, onPress}]
   * æåè°å½æ° Array or Function
   */
  callbackOrActions?: Array<any>;

  /**
   * prompt çæ ·å¼
   * String (default, secure-text, login-password)
   */
  type?: string;

  /**
   * é»è®¤å¼(input ä¸º password ç±»åä¸æ¯æ)
   */
  defaultValue?: string;

  /**
   * ['', '']
   */
  placeholders?: Array<any>;
}

@Injectable()
export class OperationOptions extends BaseOptions {
  /**
   * æé®ç», [{text, onPress, style}]
   */
  actions?: Array<any>;
}

@Injectable()
export class Action {
  text?: string;
  onPress?: Function;
  style?: {};
}
